<!-- ── Admin top bar ─────────────────────────────────────────────────────── -->
<div style="background:#0f172a;color:#f8fafc;padding:0;position:sticky;top:0;z-index:100;box-shadow:0 1px 3px rgba(0,0,0,.4);">
  <div style="display:flex;align-items:center;justify-content:space-between;height:52px;padding:0 16px;max-width:1400px;margin:0 auto;">

    <!-- Nav links — horizontal scroll on mobile -->
    <div style="display:flex;align-items:center;gap:4px;overflow-x:auto;scrollbar-width:none;-ms-overflow-style:none;flex:1;min-width:0;">
      <span style="font-size:13px;font-weight:700;letter-spacing:1px;color:#38bdf8;text-transform:uppercase;white-space:nowrap;flex-shrink:0;margin-right:8px;">TG Admin</span>
      <span style="width:1px;height:18px;background:#334155;flex-shrink:0;margin-right:4px;"></span>
      <span style="font-size:13px;font-weight:600;color:#f8fafc;padding:6px 10px;background:#1e3a5f;border-radius:4px;white-space:nowrap;flex-shrink:0;">Scraper</span>
      <a routerLink="/admin/vacantes"
         style="font-size:13px;color:#94a3b8;text-decoration:none;cursor:pointer;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Vacantes</a>
      <a routerLink="/admin/usuarios"
         style="font-size:13px;color:#94a3b8;text-decoration:none;cursor:pointer;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Usuarios</a>
      <a routerLink="/admin/gurumatch"
         style="font-size:13px;color:#94a3b8;text-decoration:none;cursor:pointer;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">GuruMatch</a>
      <a routerLink="/admin/suscripciones"
         style="font-size:13px;color:#94a3b8;text-decoration:none;cursor:pointer;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Suscripciones</a>
      <a routerLink="/admin/config"
         style="font-size:13px;color:#94a3b8;text-decoration:none;cursor:pointer;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Config</a>
      <a routerLink="/admin/social"
         style="font-size:13px;color:#94a3b8;text-decoration:none;cursor:pointer;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Redes Sociales</a>
    </div>

    <!-- Action buttons — always visible -->
    <div style="display:flex;align-items:center;gap:6px;flex-shrink:0;margin-left:8px;">
      <!-- Logged-in user badge -->
      <span *ngIf="usuarioLogueado"
            style="font-size:11px;color:#94a3b8;background:#1e293b;border:1px solid #334155;border-radius:20px;padding:3px 10px;white-space:nowrap;max-width:160px;overflow:hidden;text-overflow:ellipsis;"
            [title]="usuarioLogueado">
        👤 {{ usuarioLogueado }}
      </span>
      <button (click)="abrirConfirmacion()" [disabled]="ejecutando || scraperEnEjecucion"
              style="display:inline-flex;align-items:center;gap:5px;background:#0ea5e9;color:#fff;border:none;border-radius:6px;padding:6px 12px;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;"
              [style.opacity]="(ejecutando || scraperEnEjecucion) ? '0.5' : '1'"
              [style.cursor]="(ejecutando || scraperEnEjecucion) ? 'not-allowed' : 'pointer'">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style="width:13px;height:13px;flex-shrink:0;"
             [style.animation]="(ejecutando || scraperEnEjecucion) ? 'spin 1s linear infinite' : 'none'">
          <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/>
        </svg>
        <span style="display:none;" class="scraper-label-full">{{ ejecutando ? 'Iniciando...' : scraperEnEjecucion ? 'En ejecución...' : 'Ejecutar Scraper' }}</span>
        <span>{{ ejecutando ? '...' : scraperEnEjecucion ? '...' : '▶' }}</span>
      </button>
      <button *ngIf="scraperEnEjecucion" (click)="detenerScraper()" [disabled]="deteniendo"
              style="display:inline-flex;align-items:center;gap:5px;background:#ef4444;color:#fff;border:none;border-radius:6px;padding:6px 12px;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;"
              [style.opacity]="deteniendo ? '0.5' : '1'"
              [style.cursor]="deteniendo ? 'not-allowed' : 'pointer'">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style="width:13px;height:13px;flex-shrink:0;">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
        </svg>
        {{ deteniendo ? 'Deteniendo...' : 'Detener' }}
      </button>
      <button *ngIf="!scraperEnEjecucion" (click)="repararStatus()" [disabled]="reparandoStatus"
              title="Sincroniza status PUBLICADO en MongoDB para vacantes que ya existen en MySQL"
              style="display:inline-flex;align-items:center;gap:5px;background:#7c3aed;color:#fff;border:none;border-radius:6px;padding:6px 10px;font-size:11px;font-weight:600;cursor:pointer;white-space:nowrap;"
              [style.opacity]="reparandoStatus ? '0.5' : '1'">
        🔧 {{ reparandoStatus ? '...' : 'Reparar' }}
      </button>
      <button (click)="cerrarSesion()"
              style="display:inline-flex;align-items:center;gap:5px;background:#7f1d1d;color:#fca5a5;border:none;border-radius:6px;padding:6px 12px;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style="width:13px;height:13px;flex-shrink:0;">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75"/>
        </svg>
        Salir
      </button>
    </div>
  </div>
</div>

<!-- ── Banner: Scraper en ejecución ──────────────────────────────────────── -->
<div *ngIf="scraperEnEjecucion"
     style="background:#fef3c7;border-bottom:2px solid #f59e0b;padding:10px 0;">
  <div class="tg-container" style="display:flex;align-items:center;gap:10px;">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
         stroke="#d97706" style="width:16px;height:16px;flex-shrink:0;animation:spin 1s linear infinite;">
      <path stroke-linecap="round" stroke-linejoin="round"
            d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/>
    </svg>
    <span style="font-size:13px;font-weight:600;color:#92400e;">
      Scraper en ejecución — el historial y las stats se actualizarán automáticamente al terminar.
    </span>
  </div>
</div>

<!-- ── Stats bar ─────────────────────────────────────────────────────────── -->
<div style="background:#1e293b;padding:12px 0;border-bottom:1px solid #334155;">
  <div class="tg-container">
    <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(100px,1fr));gap:8px;">

      <div style="text-align:center;padding:10px 8px;border-radius:8px;background:#0f172a;">
        <div style="font-size:1.4rem;font-weight:800;color:#f59e0b;line-height:1;">{{stats.total}}</div>
        <div style="font-size:10px;color:#94a3b8;margin-top:3px;text-transform:uppercase;letter-spacing:.5px;">Total</div>
      </div>

      <div style="text-align:center;padding:10px 8px;border-radius:8px;background:#0f172a;">
        <div style="font-size:1.4rem;font-weight:800;color:#4ade80;line-height:1;">{{stats.publicadas}}</div>
        <div style="font-size:10px;color:#94a3b8;margin-top:3px;text-transform:uppercase;letter-spacing:.5px;">Publicadas</div>
      </div>

      <div style="text-align:center;padding:10px 8px;border-radius:8px;background:#0f172a;">
        <div style="font-size:1.4rem;font-weight:800;color:#f87171;line-height:1;">{{stats.rechazadas}}</div>
        <div style="font-size:10px;color:#94a3b8;margin-top:3px;text-transform:uppercase;letter-spacing:.5px;">Rechazadas</div>
      </div>

      <div *ngIf="stats.pendientes > 0" style="text-align:center;padding:10px 8px;border-radius:8px;background:#0f172a;">
        <div style="font-size:1.4rem;font-weight:800;color:#a78bfa;line-height:1;">{{stats.pendientes}}</div>
        <div style="font-size:10px;color:#94a3b8;margin-top:3px;text-transform:uppercase;letter-spacing:.5px;">Pendientes</div>
      </div>

      <div *ngFor="let f of fuentesStats"
           style="text-align:center;padding:10px 8px;border-radius:8px;background:#0f172a;">
        <div style="font-size:1.4rem;font-weight:800;color:#38bdf8;line-height:1;">{{f.count}}</div>
        <div style="font-size:10px;color:#94a3b8;margin-top:3px;text-transform:uppercase;letter-spacing:.5px;">{{f.fuente}}</div>
      </div>

    </div>
  </div>
</div>

<!-- ── Tabs ──────────────────────────────────────────────────────────────── -->
<div style="background:#fff;border-bottom:2px solid #e5e7eb;">
  <div class="tg-container" style="display:flex;gap:0;">
    <button (click)="tabActiva = 'config'"
            [style.border-bottom]="tabActiva === 'config' ? '2px solid #0ea5e9' : '2px solid transparent'"
            [style.color]="tabActiva === 'config' ? '#0ea5e9' : '#6b7280'"
            style="background:none;border:none;border-top:none;border-left:none;border-right:none;padding:14px 20px;font-size:13px;font-weight:600;cursor:pointer;position:relative;top:2px;transition:all .15s;">
      Configuración
      <span *ngIf="!iaSet"
            style="background:#fde047;color:#78350f;border-radius:100px;padding:1px 7px;font-size:10px;font-weight:700;margin-left:6px;"
            title="Token de IA no configurado — las vacantes no se enriquecerán en español">
        Sin IA
      </span>
    </button>
    <button (click)="tabActiva = 'historial'"
            [style.border-bottom]="tabActiva === 'historial' ? '2px solid #0ea5e9' : '2px solid transparent'"
            [style.color]="tabActiva === 'historial' ? '#0ea5e9' : '#6b7280'"
            style="background:none;border:none;border-top:none;border-left:none;border-right:none;padding:14px 20px;font-size:13px;font-weight:600;cursor:pointer;position:relative;top:2px;transition:all .15s;">
      Historial
      <span *ngIf="historial.length > 0"
            style="background:#64748b;color:#fff;border-radius:100px;padding:1px 7px;font-size:10px;font-weight:700;margin-left:6px;">
        {{historial.length}}
      </span>
    </button>
  </div>
</div>

<!-- ── Tab: Configuración ────────────────────────────────────────────────── -->
<section *ngIf="tabActiva === 'config'" style="background:#f1f5f9;padding:28px 0 72px;">
  <div class="tg-container">
    <div style="max-width:680px;">

      <!-- Header -->
      <div style="margin-bottom:24px;">
        <h2 style="font-size:17px;font-weight:700;color:#0f172a;margin:0 0 4px;">Configuración del Scraper</h2>
        <p style="font-size:13px;color:#64748b;margin:0;">Los cambios se aplican de forma inmediata sin reiniciar el servidor.</p>
      </div>

      <!-- Mensaje config -->
      <div *ngIf="mensajeConfig"
           [style.background]="mensajeConfigError ? '#fef2f2' : '#f0fdf4'"
           [style.border-color]="mensajeConfigError ? '#fecaca' : '#bbf7d0'"
           [style.color]="mensajeConfigError ? '#dc2626' : '#15803d'"
           style="border:1px solid;border-radius:8px;padding:10px 14px;margin-bottom:20px;font-size:13px;">
        {{ mensajeConfig }}
      </div>

      <!-- Fuentes -->
      <div style="background:#fff;border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;margin-bottom:16px;">
        <div style="padding:14px 18px;border-bottom:1px solid #f1f5f9;background:#f8fafc;">
          <span style="font-size:11px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.6px;">Fuentes de Scraping</span>
        </div>
        <div style="padding:18px;">

          <!-- OCC -->
          <div style="display:flex;align-items:center;gap:16px;padding:12px 0;border-bottom:1px solid #f1f5f9;">
            <div style="flex:1;">
              <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:2px;">OCC Mundial</div>
              <div style="font-size:11px;color:#94a3b8;">occ.com.mx — Bolsa de empleo general</div>
            </div>
            <div style="display:flex;align-items:center;gap:12px;">
              <div style="display:flex;align-items:center;gap:6px;">
                <label style="font-size:11px;color:#64748b;">Páginas</label>
                <input type="number" [(ngModel)]="configForm.occMaxPages" min="1" max="20"
                       style="width:56px;padding:4px 8px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;text-align:center;color:#0f172a;">
              </div>
              <label style="display:flex;align-items:center;gap:6px;cursor:pointer;">
                <input type="checkbox" [(ngModel)]="configForm.occEnabled"
                       style="width:16px;height:16px;accent-color:#0ea5e9;">
                <span style="font-size:12px;color:#64748b;">Activo</span>
              </label>
              <select [(ngModel)]="configForm.occRun"
                      style="padding:4px 6px;border:1px solid #e2e8f0;border-radius:6px;font-size:11px;color:#0f172a;background:#fff;cursor:pointer;">
                <option value="BOTH">Ambas</option>
                <option value="RUN_1">1ra ejec.</option>
                <option value="RUN_2">2da ejec.</option>
              </select>
            </div>
          </div>

          <!-- Computrabajo -->
          <div style="display:flex;align-items:center;gap:16px;padding:12px 0;border-bottom:1px solid #f1f5f9;">
            <div style="flex:1;">
              <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:2px;">Computrabajo</div>
              <div style="font-size:11px;color:#94a3b8;">computrabajo.com.mx</div>
            </div>
            <div style="display:flex;align-items:center;gap:12px;">
              <div style="display:flex;align-items:center;gap:6px;">
                <label style="font-size:11px;color:#64748b;">Páginas</label>
                <input type="number" [(ngModel)]="configForm.ctMaxPages" min="1" max="20"
                       style="width:56px;padding:4px 8px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;text-align:center;color:#0f172a;">
              </div>
              <label style="display:flex;align-items:center;gap:6px;cursor:pointer;">
                <input type="checkbox" [(ngModel)]="configForm.ctEnabled"
                       style="width:16px;height:16px;accent-color:#0ea5e9;">
                <span style="font-size:12px;color:#64748b;">Activo</span>
              </label>
              <select [(ngModel)]="configForm.ctRun"
                      style="padding:4px 6px;border:1px solid #e2e8f0;border-radius:6px;font-size:11px;color:#0f172a;background:#fff;cursor:pointer;">
                <option value="BOTH">Ambas</option>
                <option value="RUN_1">1ra ejec.</option>
                <option value="RUN_2">2da ejec.</option>
              </select>
            </div>
          </div>

          <!-- Hireline -->
          <div style="display:flex;align-items:center;gap:16px;padding:12px 0;border-bottom:1px solid #f1f5f9;">
            <div style="flex:1;">
              <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:2px;">Hireline</div>
              <div style="font-size:11px;color:#94a3b8;">hireline.io — Bolsa tech MX/LATAM</div>
            </div>
            <div style="display:flex;align-items:center;gap:12px;">
              <div style="display:flex;align-items:center;gap:6px;">
                <label style="font-size:11px;color:#64748b;">Páginas</label>
                <input type="number" [(ngModel)]="configForm.hlMaxPages" min="1" max="20"
                       style="width:56px;padding:4px 8px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;text-align:center;color:#0f172a;">
              </div>
              <label style="display:flex;align-items:center;gap:6px;cursor:pointer;">
                <input type="checkbox" [(ngModel)]="configForm.hlEnabled"
                       style="width:16px;height:16px;accent-color:#0ea5e9;">
                <span style="font-size:12px;color:#64748b;">Activo</span>
              </label>
              <select [(ngModel)]="configForm.hlRun"
                      style="padding:4px 6px;border:1px solid #e2e8f0;border-radius:6px;font-size:11px;color:#0f172a;background:#fff;cursor:pointer;">
                <option value="BOTH">Ambas</option>
                <option value="RUN_1">1ra ejec.</option>
                <option value="RUN_2">2da ejec.</option>
              </select>
            </div>
          </div>

          <!-- LinkedIn / Apify — activar/desactivar y personalizar cada actor en "Apify — Actors" (abajo) -->
          <div style="display:flex;align-items:center;gap:16px;padding:12px 0;">
            <div style="flex:1;">
              <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:2px;">LinkedIn <span style="font-size:10px;font-weight:600;background:#ecfeff;color:#0e7490;padding:1px 7px;border-radius:100px;border:1px solid #a5f3fc;vertical-align:middle;">Apify</span></div>
              <div style="font-size:11px;color:#94a3b8;">
                {{ configForm.apifyActors.length }} actor(es) configurados,
                {{ apifyActorsActivos() }} activo(s).
                Cada actor se activa/desactiva y personaliza individualmente en la sección "Apify — Actors" más abajo.
              </div>
            </div>
          </div>

          <!-- Remotive -->
          <div style="display:flex;align-items:center;gap:16px;padding:12px 0;border-top:1px solid #f1f5f9;">
            <div style="flex:1;">
              <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:2px;">Remotive <span style="font-size:10px;font-weight:600;background:#f0fdf4;color:#15803d;padding:1px 7px;border-radius:100px;border:1px solid #bbf7d0;vertical-align:middle;">API</span></div>
              <div style="font-size:11px;color:#94a3b8;">remotive.com — API pública global, empleos 100% remotos</div>
            </div>
            <div style="display:flex;align-items:center;gap:12px;">
              <div style="display:flex;align-items:center;gap:6px;">
                <label style="font-size:11px;color:#64748b;">Máx.</label>
                <input type="number" [(ngModel)]="configForm.remotiveMaxJobs" min="10" max="500"
                       style="width:64px;padding:4px 8px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;text-align:center;color:#0f172a;">
              </div>
              <label style="display:flex;align-items:center;gap:6px;cursor:pointer;">
                <input type="checkbox" [(ngModel)]="configForm.remotiveEnabled"
                       style="width:16px;height:16px;accent-color:#22c55e;">
                <span style="font-size:12px;color:#64748b;">Activo</span>
              </label>
              <select [(ngModel)]="configForm.remotiveRun"
                      style="padding:4px 6px;border:1px solid #e2e8f0;border-radius:6px;font-size:11px;color:#0f172a;background:#fff;cursor:pointer;">
                <option value="BOTH">Ambas</option>
                <option value="RUN_1">1ra ejec.</option>
                <option value="RUN_2">2da ejec.</option>
              </select>
            </div>
          </div>

          <!-- Himalayas -->
          <div style="display:flex;align-items:center;gap:16px;padding:12px 0;border-top:1px solid #f1f5f9;">
            <div style="flex:1;">
              <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:2px;">Himalayas <span style="font-size:10px;font-weight:600;background:#f0fdf4;color:#15803d;padding:1px 7px;border-radius:100px;border:1px solid #bbf7d0;vertical-align:middle;">API</span></div>
              <div style="font-size:11px;color:#94a3b8;">himalayas.app — API JSON, empleos tech remotos globales</div>
            </div>
            <div style="display:flex;align-items:center;gap:12px;">
              <div style="display:flex;align-items:center;gap:6px;">
                <label style="font-size:11px;color:#64748b;">Máx.</label>
                <input type="number" [(ngModel)]="configForm.himalayanMaxJobs" min="10" max="500"
                       style="width:64px;padding:4px 8px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;text-align:center;color:#0f172a;">
              </div>
              <label style="display:flex;align-items:center;gap:6px;cursor:pointer;">
                <input type="checkbox" [(ngModel)]="configForm.himalayanEnabled"
                       style="width:16px;height:16px;accent-color:#22c55e;">
                <span style="font-size:12px;color:#64748b;">Activo</span>
              </label>
              <select [(ngModel)]="configForm.himalayanRun"
                      style="padding:4px 6px;border:1px solid #e2e8f0;border-radius:6px;font-size:11px;color:#0f172a;background:#fff;cursor:pointer;">
                <option value="BOTH">Ambas</option>
                <option value="RUN_1">1ra ejec.</option>
                <option value="RUN_2">2da ejec.</option>
              </select>
            </div>
          </div>

          <!-- Working Nomads -->
          <div style="display:flex;align-items:center;gap:16px;padding:12px 0;border-top:1px solid #f1f5f9;">
            <div style="flex:1;">
              <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:2px;">Working Nomads <span style="font-size:10px;font-weight:600;background:#f0fdf4;color:#15803d;padding:1px 7px;border-radius:100px;border:1px solid #bbf7d0;vertical-align:middle;">API</span></div>
              <div style="font-size:11px;color:#94a3b8;">workingnomads.com — JSON API, empleos remotos de desarrollo</div>
            </div>
            <div style="display:flex;align-items:center;gap:12px;">
              <div style="display:flex;align-items:center;gap:6px;">
                <label style="font-size:11px;color:#64748b;">Máx.</label>
                <input type="number" [(ngModel)]="configForm.workingNomadsMaxJobs" min="10" max="500"
                       style="width:64px;padding:4px 8px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;text-align:center;color:#0f172a;">
              </div>
              <label style="display:flex;align-items:center;gap:6px;cursor:pointer;">
                <input type="checkbox" [(ngModel)]="configForm.workingNomadsEnabled"
                       style="width:16px;height:16px;accent-color:#22c55e;">
                <span style="font-size:12px;color:#64748b;">Activo</span>
              </label>
              <select [(ngModel)]="configForm.workingNomadsRun"
                      style="padding:4px 6px;border:1px solid #e2e8f0;border-radius:6px;font-size:11px;color:#0f172a;background:#fff;cursor:pointer;">
                <option value="BOTH">Ambas</option>
                <option value="RUN_1">1ra ejec.</option>
                <option value="RUN_2">2da ejec.</option>
              </select>
            </div>
          </div>

          <!-- We Work Remotely -->
          <div style="display:flex;align-items:center;gap:16px;padding:12px 0;border-top:1px solid #f1f5f9;">
            <div style="flex:1;">
              <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:2px;">We Work Remotely <span style="font-size:10px;font-weight:600;background:#fffbeb;color:#b45309;padding:1px 7px;border-radius:100px;border:1px solid #fde68a;vertical-align:middle;">RSS</span></div>
              <div style="font-size:11px;color:#94a3b8;">weworkremotely.com — feed RSS público, empleos 100% remotos</div>
            </div>
            <div style="display:flex;align-items:center;gap:12px;">
              <div style="display:flex;align-items:center;gap:6px;">
                <label style="font-size:11px;color:#64748b;">Máx.</label>
                <input type="number" [(ngModel)]="configForm.wwrMaxJobs" min="10" max="500"
                       style="width:64px;padding:4px 8px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;text-align:center;color:#0f172a;">
              </div>
              <label style="display:flex;align-items:center;gap:6px;cursor:pointer;">
                <input type="checkbox" [(ngModel)]="configForm.wwrEnabled"
                       style="width:16px;height:16px;accent-color:#f59e0b;">
                <span style="font-size:12px;color:#64748b;">Activo</span>
              </label>
              <select [(ngModel)]="configForm.wwrRun"
                      style="padding:4px 6px;border:1px solid #e2e8f0;border-radius:6px;font-size:11px;color:#0f172a;background:#fff;cursor:pointer;">
                <option value="BOTH">Ambas</option>
                <option value="RUN_1">1ra ejec.</option>
                <option value="RUN_2">2da ejec.</option>
              </select>
            </div>
          </div>

        </div>
      </div>

      <!-- Proxies Premium -->
      <div style="background:#fff;border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;margin-bottom:16px;">
        <div style="padding:14px 18px;border-bottom:1px solid #f1f5f9;background:#f8fafc;">
          <h3 style="font-size:14px;font-weight:700;color:#0f172a;margin:0;">Proxies Premium</h3>
          <p style="font-size:11px;color:#64748b;margin:4px 0 0;">
            Un proxy por línea. Formato: <code>ip:puerto:usuario:password</code> o <code>http://usuario:password@ip:puerto</code>.
            Proxies gratis: <a href="https://dashboard.webshare.io/" target="_blank" style="color:#2563eb;">webshare.io</a>
            (10 proxies/mes gratis con cuenta).
          </p>
        </div>
        <div style="padding:12px 18px;">
          <textarea [(ngModel)]="configForm.premiumProxies" rows="8"
                    placeholder="31.59.20.176:6754:user:pass"
                    style="width:100%;padding:8px 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:11px;color:#0f172a;font-family:monospace;resize:vertical;box-sizing:border-box;"></textarea>
          <div style="display:flex;align-items:center;gap:10px;margin-top:8px;">
            <button (click)="probarProxy()" [disabled]="probandoProxy"
                    style="background:#2563eb;color:#fff;border:none;border-radius:6px;padding:5px 12px;font-size:11px;font-weight:600;cursor:pointer;">
              {{ probandoProxy ? 'Probando...' : 'Probar proxy (google.com)' }}
            </button>
            <span *ngIf="resultadoProxy" [style.color]="resultadoProxy.ok ? '#16a34a' : '#dc2626'" style="font-size:11px;">
              {{ resultadoProxy.ok ? 'OK ' + resultadoProxy.httpStatus + ' en ' + resultadoProxy.tiempoMs + 'ms' : 'FAIL: ' + (resultadoProxy.error || '') }}
            </span>
          </div>
        </div>
      </div>

      <!-- Pausa -->
      <div style="background:#fff;border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;margin-bottom:16px;">
        <div style="padding:14px 18px;border-bottom:1px solid #f1f5f9;background:#f8fafc;">
          <span style="font-size:11px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.6px;">Rendimiento</span>
        </div>
        <div style="padding:18px;">
          <div style="display:flex;align-items:center;gap:16px;">
            <div style="flex:1;">
              <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:2px;">Pausa manual entre páginas</div>
              <div style="font-size:11px;color:#94a3b8;">Segundos de espera entre cada solicitud HTTP cuando el scraping es manual</div>
            </div>
            <div style="display:flex;align-items:center;gap:8px;">
              <input type="number" [(ngModel)]="configForm.pauseMs" min="5000" max="120000" step="5000"
                     style="width:90px;padding:6px 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;text-align:center;color:#0f172a;">
              <span style="font-size:12px;color:#94a3b8;">ms ({{ configForm.pauseMs / 1000 }}s)</span>
            </div>
          </div>
          <!-- Rango automático -->
          <div style="display:flex;align-items:center;gap:16px;margin-top:14px;padding-top:14px;border-top:1px solid #f1f5f9;">
            <div style="flex:1;">
              <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:2px;">Pausa automática (rango aleatorio)</div>
              <div style="font-size:11px;color:#94a3b8;">El scheduler nocturno elige un valor aleatorio entre estos límites en cada solicitud</div>
            </div>
            <div style="display:flex;align-items:center;gap:8px;">
              <input type="number" [(ngModel)]="configForm.autoMinPauseMs" min="5000" max="120000" step="5000"
                     style="width:90px;padding:6px 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;text-align:center;color:#0f172a;">
              <span style="font-size:12px;color:#94a3b8;">–</span>
              <input type="number" [(ngModel)]="configForm.autoMaxPauseMs" min="5000" max="120000" step="5000"
                     style="width:90px;padding:6px 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;text-align:center;color:#0f172a;">
              <span style="font-size:12px;color:#94a3b8;">ms ({{ configForm.autoMinPauseMs / 1000 }}s – {{ configForm.autoMaxPauseMs / 1000 }}s)</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Inteligencia Artificial -->
      <div style="background:#fff;border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;margin-bottom:16px;">
        <div style="padding:14px 18px;border-bottom:1px solid #f1f5f9;background:#f8fafc;">
          <span style="font-size:11px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.6px;">Inteligencia Artificial</span>
        </div>
        <div style="padding:18px;display:flex;flex-direction:column;gap:14px;">

          <!-- Modelo -->
          <div style="display:flex;align-items:center;gap:16px;">
            <div style="flex:1;">
              <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:2px;">Modelo</div>
              <div style="font-size:11px;color:#94a3b8;">Modelo de IA para normalizar y enriquecer vacantes</div>
            </div>
            <select [(ngModel)]="configForm.iaModelo"
                    style="padding:6px 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;color:#0f172a;background:#fff;">
              <option value="deepseek-v4-flash">DeepSeek V4 Flash (económico)</option>
              <option value="deepseek-v4-pro">DeepSeek V4 Pro</option>
              <option value="claude-haiku-4-5-20251001">Claude Haiku 4.5</option>
              <option value="claude-sonnet-4-6">Claude Sonnet 4.6</option>
            </select>
          </div>

          <!-- IA Token unificado -> Admin Config -->
          <div style="padding:10px 12px;border-radius:8px;font-size:12px;"
               [style.background]="iaSet ? '#ecfdf5' : '#fef3c7'"
               [style.border]="iaSet ? '1px solid #a7f3d0' : '1px solid #fde047'">
            <strong [style.color]="iaSet ? '#059669' : '#d97706'">{{ iaSet ? '✅ Token DeepSeek configurado' : '⚠ Sin token DeepSeek' }}</strong>
            <span style="color:#64748b;display:block;margin-top:2px;">
              {{ iaSet ? 'El scraper usará IA para enriquecer vacantes.' : 'Las vacantes se guardarán sin IA.' }}
              Se gestiona en <a routerLink="/admin/config" style="color:#4f46e5;font-weight:600;text-decoration:underline;">Admin → Configuración → DeepSeek</a>
            </span>
          </div>

        </div>
      </div>

      <!-- Apify — Actors -->
      <div style="background:#fff;border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;margin-bottom:16px;">
        <div style="padding:14px 18px;border-bottom:1px solid #f1f5f9;background:#f8fafc;display:flex;align-items:center;justify-content:space-between;">
          <span style="font-size:11px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.6px;">Apify — Actors</span>
          <div style="display:flex;gap:8px;">
            <button type="button" (click)="agregarApifyActor('LINKEDIN')"
                    style="padding:4px 12px;background:#0ea5e9;color:#fff;border:none;border-radius:6px;font-size:11px;font-weight:600;cursor:pointer;">
              + LinkedIn
            </button>
            <button type="button" (click)="agregarApifyActor('GETONBRD')"
                    style="padding:4px 12px;background:#7c3aed;color:#fff;border:none;border-radius:6px;font-size:11px;font-weight:600;cursor:pointer;">
              + Get on Board
            </button>
          </div>
        </div>
        <div style="padding:18px;display:flex;flex-direction:column;gap:16px;">

          <div style="padding:10px 12px;background:#ecfeff;border:1px solid #a5f3fc;border-radius:8px;font-size:12px;color:#0e7490;">
            Cada actor apunta a una fuente real distinta (LinkedIn, Get on Board) — no son copias del mismo scraper.
            Se activa/desactiva y personaliza de forma independiente.
            Obtener token: <a href="https://console.apify.com/settings/integrations" target="_blank" style="color:#0e7490;font-weight:700;">console.apify.com → Settings → Integrations → API tokens</a>
          </div>

          <div *ngIf="configForm.apifyActors.length === 0" style="font-size:13px;color:#94a3b8;text-align:center;padding:16px 0;">
            Sin actors configurados. Presiona "+ LinkedIn" o "+ Get on Board" para crear el primero.
          </div>

          <div *ngFor="let actor of configForm.apifyActors; let i = index"
               style="border:1px solid #e2e8f0;border-radius:10px;padding:16px;display:flex;flex-direction:column;gap:14px;background:#fafafa;">

            <!-- Header: label + sourceType + enabled + run + eliminar -->
            <div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;">
              <input type="text" [(ngModel)]="actor.label" placeholder="Nombre del actor (ej. LinkedIn México Backend)"
                     style="flex:1;min-width:180px;padding:6px 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;font-weight:600;color:#0f172a;">
              <span style="font-size:10px;font-weight:700;padding:2px 8px;border-radius:100px;"
                    [style.background]="actor.sourceType === 'GETONBRD' ? '#f3e8ff' : '#ecfeff'"
                    [style.color]="actor.sourceType === 'GETONBRD' ? '#7c3aed' : '#0e7490'">
                {{ actor.sourceType === 'GETONBRD' ? 'Get on Board' : 'LinkedIn' }}
              </span>
              <label style="display:flex;align-items:center;gap:6px;cursor:pointer;">
                <input type="checkbox" [(ngModel)]="actor.enabled" style="width:16px;height:16px;accent-color:#0ea5e9;">
                <span style="font-size:12px;color:#64748b;">Activo</span>
              </label>
              <select [(ngModel)]="actor.run"
                      style="padding:4px 6px;border:1px solid #e2e8f0;border-radius:6px;font-size:11px;color:#0f172a;background:#fff;cursor:pointer;">
                <option value="BOTH">Ambas</option>
                <option value="RUN_1">1ra ejec.</option>
                <option value="RUN_2">2da ejec.</option>
              </select>
              <button type="button" (click)="eliminarApifyActor(i)"
                      style="padding:5px 10px;border:1px solid #fecaca;border-radius:6px;background:#fef2f2;color:#dc2626;font-size:11px;font-weight:600;cursor:pointer;">
                Eliminar
              </button>
            </div>

            <!-- API Token -->
            <div style="display:flex;align-items:flex-start;gap:16px;">
              <div style="flex:1;">
                <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:2px;">
                  API Token de Apify
                  <span *ngIf="actor.tokenSet" style="font-size:10px;font-weight:600;background:#dcfce7;color:#15803d;padding:1px 7px;border-radius:100px;margin-left:6px;">✓ Configurado</span>
                  <span *ngIf="!actor.tokenSet" style="font-size:10px;font-weight:600;background:#fef9c3;color:#78350f;padding:1px 7px;border-radius:100px;margin-left:6px;">Sin configurar</span>
                </div>
                <div style="font-size:11px;color:#94a3b8;">
                  {{ actor.tokenSet ? 'Token activo. Escribe uno nuevo para reemplazarlo.' : 'Requerido para que este actor pueda ejecutarse.' }}
                </div>
              </div>
              <div style="display:flex;align-items:center;gap:6px;">
                <input [type]="mostrarApifyToken[actor.id] ? 'text' : 'password'" [(ngModel)]="actor.token"
                       autocomplete="new-password"
                       [placeholder]="actor.tokenSet ? 'Escribe nuevo token para reemplazar' : 'apify_api_xxxxxxxxxxxxxxxx'"
                       style="width:220px;padding:6px 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;color:#0f172a;font-family:monospace;">
                <button type="button" (click)="toggleRevealApifyToken(actor.id)" [disabled]="loadingTokens"
                        title="{{ mostrarApifyToken[actor.id] ? 'Ocultar token' : 'Ver token completo' }}"
                        style="padding:5px 8px;border:1px solid #e2e8f0;border-radius:6px;background:#f8fafc;cursor:pointer;display:flex;align-items:center;color:#64748b;">
                  <svg *ngIf="mostrarApifyToken[actor.id]" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                  <svg *ngIf="!mostrarApifyToken[actor.id]" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                </button>
              </div>
            </div>

            <!-- Actor ID -->
            <div style="display:flex;align-items:center;gap:16px;">
              <div style="flex:1;">
                <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:2px;">Actor ID</div>
                <div style="font-size:11px;color:#94a3b8;">
                  Actor de Apify a ejecutar. Por defecto:
                  <code style="background:#f1f5f9;padding:1px 4px;border-radius:3px;">{{ actor.sourceType === 'GETONBRD' ? 'jungle_synthesizer/getonbrd-latam-tech-jobs-scraper' : 'curious_coder/linkedin-jobs-scraper' }}</code>
                </div>
              </div>
              <input type="text" [(ngModel)]="actor.actorId"
                     style="width:260px;padding:6px 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:12px;color:#0f172a;font-family:monospace;">
            </div>

            <!-- Campos LinkedIn -->
            <ng-container *ngIf="actor.sourceType !== 'GETONBRD'">
              <!-- Queries -->
              <div>
                <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:4px;">Búsquedas (una por línea)</div>
                <div style="font-size:11px;color:#94a3b8;margin-bottom:6px;">Términos de búsqueda para LinkedIn. Ej: <em>Java Spring Boot</em>, <em>Full Stack Developer</em></div>
                <textarea [(ngModel)]="actor.queries" rows="5"
                          placeholder="Java Spring Boot&#10;Full Stack Developer&#10;React Angular&#10;DevOps Cloud AWS&#10;Data Scientist"
                          style="width:100%;padding:8px 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:12px;color:#0f172a;font-family:monospace;resize:vertical;box-sizing:border-box;"></textarea>
              </div>

              <!-- Locations -->
              <div>
                <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:4px;">Ubicaciones (una por línea)</div>
                <div style="font-size:11px;color:#94a3b8;margin-bottom:6px;">Países o ciudades para filtrar los resultados de LinkedIn</div>
                <textarea [(ngModel)]="actor.locations" rows="4"
                          placeholder="Mexico"
                          style="width:100%;padding:8px 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:12px;color:#0f172a;font-family:monospace;resize:vertical;box-sizing:border-box;"></textarea>
              </div>

              <!-- Workplace types + Date posted + Límite/query + queries por corrida -->
              <div style="display:flex;align-items:center;gap:16px;flex-wrap:wrap;">
                <div style="flex:1;min-width:180px;">
                  <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:4px;">Tipo de trabajo</div>
                  <select [(ngModel)]="actor.workplaceTypes"
                          style="width:100%;padding:6px 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;color:#0f172a;background:#fff;">
                    <option value="remote">Remoto</option>
                    <option value="onSite">Presencial</option>
                    <option value="hybrid">Híbrido</option>
                    <option value="remote,hybrid">Remoto + Híbrido</option>
                  </select>
                </div>
                <div style="flex:1;min-width:180px;">
                  <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:4px;">Antigüedad de publicación</div>
                  <select [(ngModel)]="actor.datePosted"
                          style="width:100%;padding:6px 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;color:#0f172a;background:#fff;">
                    <option value="past_24_hours">Últimas 24 horas</option>
                    <option value="past_week">Última semana</option>
                    <option value="past_month">Último mes</option>
                    <option value="">Sin filtro</option>
                  </select>
                </div>
                <div style="display:flex;align-items:center;gap:6px;">
                  <label style="font-size:11px;color:#64748b;">Máx. items/corrida</label>
                  <input type="number" [(ngModel)]="actor.maxItemsPerRun" min="5" max="200"
                         style="width:56px;padding:4px 8px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;text-align:center;color:#0f172a;">
                </div>
                <div style="display:flex;align-items:center;gap:6px;">
                  <label style="font-size:11px;color:#64748b;">Queries/corrida</label>
                  <input type="number" [(ngModel)]="actor.queriesPerRun" min="1" max="50"
                         style="width:56px;padding:4px 8px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;text-align:center;color:#0f172a;">
                </div>
              </div>

              <!-- Solo solicitud sencilla (Easy Apply) -->
              <label style="display:flex;align-items:center;gap:8px;cursor:pointer;font-size:13px;color:#334155;">
                <input type="checkbox" [(ngModel)]="actor.soloSolicitudSencilla">
                Solo vacantes con "Solicitud sencilla" (Easy Apply) de LinkedIn
              </label>
            </ng-container>

            <!-- Campos Get on Board -->
            <ng-container *ngIf="actor.sourceType === 'GETONBRD'">
              <div>
                <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:4px;">Categorías (una por línea)</div>
                <div style="font-size:11px;color:#94a3b8;margin-bottom:6px;">
                  Slugs de categoría de Get on Board. Ej: <em>programming</em>, <em>sysadmin-devops-qa</em>, <em>data-science-analytics</em>, <em>mobile-developer</em>, <em>machine-learning-ai</em>, <em>design-ux</em>, <em>cybersecurity</em>. Vacío = todas.
                </div>
                <textarea [(ngModel)]="actor.categories" rows="5"
                          placeholder="programming&#10;sysadmin-devops-qa&#10;data-science-analytics"
                          style="width:100%;padding:8px 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:12px;color:#0f172a;font-family:monospace;resize:vertical;box-sizing:border-box;"></textarea>
              </div>
              <div style="display:flex;align-items:center;gap:16px;">
                <div style="flex:1;">
                  <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:2px;">Máximo de vacantes por corrida</div>
                  <div style="font-size:11px;color:#94a3b8;">Se filtran a México (cualquier modalidad) o 100% remoto (cualquier país LATAM) antes de guardarse. 0 = sin límite (cuidado con el costo).</div>
                </div>
                <input type="number" [(ngModel)]="actor.maxItems" min="0" max="5000"
                       style="width:100px;padding:6px 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;text-align:center;color:#0f172a;">
              </div>
            </ng-container>

            <!-- Balance de esta cuenta Apify -->
            <div style="border-top:1px solid #e2e8f0;padding-top:12px;">
              <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;">
                <span style="font-size:11px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.5px;">Saldo de esta cuenta</span>
                <button (click)="cargarApifyBalance(actor.id)" [disabled]="cargandoBalance[actor.id] || !actor.tokenSet"
                        style="display:inline-flex;align-items:center;gap:5px;padding:4px 12px;background:#ecfeff;color:#0e7490;border:1px solid #a5f3fc;border-radius:6px;font-size:11px;font-weight:600;cursor:pointer;"
                        [style.opacity]="(cargandoBalance[actor.id] || !actor.tokenSet) ? '0.5' : '1'">
                  {{ cargandoBalance[actor.id] ? 'Consultando...' : 'Consultar saldo' }}
                </button>
              </div>
              <div *ngIf="!actor.tokenSet" style="font-size:12px;color:#94a3b8;">Configura el token para consultar el saldo.</div>
              <div *ngIf="apifyBalances[actor.id]?.error" style="font-size:12px;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:8px 12px;">
                ⚠ {{ apifyBalances[actor.id].error }}
              </div>
              <div *ngIf="apifyBalances[actor.id] && !apifyBalances[actor.id].error" style="display:flex;flex-wrap:wrap;gap:10px;">
                <div style="flex:1 1 160px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:10px 14px;">
                  <div style="font-size:12px;font-weight:700;color:#0f172a;">{{ apifyBalances[actor.id].username }}</div>
                  <div style="font-size:11px;color:#94a3b8;">{{ apifyBalances[actor.id].email }}</div>
                  <span *ngIf="apifyBalances[actor.id].plan" style="font-size:10px;font-weight:700;background:#dcfce7;color:#15803d;padding:2px 8px;border-radius:100px;display:inline-block;margin-top:4px;">
                    {{ apifyBalances[actor.id].plan }}
                  </span>
                </div>
                <div *ngIf="apifyBalances[actor.id].monthlyUsage" style="flex:1 1 160px;background:#ecfeff;border:1px solid #a5f3fc;border-radius:8px;padding:10px 14px;">
                  <div style="font-size:10px;font-weight:700;color:#0e7490;margin-bottom:4px;">Uso este mes</div>
                  <pre style="font-size:10px;color:#0f172a;margin:0;white-space:pre-wrap;word-break:break-word;max-height:90px;overflow-y:auto;">{{ apifyBalances[actor.id].monthlyUsage | json }}</pre>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>


      <!-- Programación automática -->
      <div style="background:#fff;border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;margin-bottom:24px;">
        <div style="padding:14px 18px;border-bottom:1px solid #f1f5f9;background:#f8fafc;display:flex;align-items:center;justify-content:space-between;">
          <span style="font-size:11px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.6px;">Programación automática</span>
          <span style="font-size:11px;color:#0ea5e9;background:#f0f9ff;border:1px solid #bae6fd;border-radius:20px;padding:2px 10px;font-weight:600;">Lunes a Sábado</span>
        </div>
        <div style="padding:18px;display:flex;flex-direction:column;gap:14px;">

          <!-- Horario primario -->
          <div style="display:flex;align-items:center;gap:16px;">
            <div style="flex:1;">
              <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:2px;">Hora de ejecución (CDMX)</div>
              <div style="font-size:11px;color:#94a3b8;">Horario principal — corre de lunes a sábado. Los domingos no corre.</div>
            </div>
            <select [(ngModel)]="configForm.horaEjecucion"
                    style="padding:7px 12px;border:1px solid #e2e8f0;border-radius:6px;font-size:14px;font-weight:600;color:#0f172a;background:#fff;cursor:pointer;">
              <option *ngFor="let h of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23]" [value]="h">
                {{ h < 12 ? h + ':00 AM' : h === 12 ? '12:00 PM' : (h - 12) + ':00 PM' }}
              </option>
            </select>
          </div>

          <!-- Horario secundario -->
          <div style="display:flex;align-items:center;gap:16px;padding-top:14px;border-top:1px solid #f1f5f9;">
            <div style="flex:1;">
              <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:2px;">Segunda ejecución (opcional)</div>
              <div style="font-size:11px;color:#94a3b8;">Horario adicional por si el primero falla o para capturar vacantes de otro turno.</div>
            </div>
            <select [(ngModel)]="configForm.horaEjecucion2"
                    style="padding:7px 12px;border:1px solid #e2e8f0;border-radius:6px;font-size:14px;font-weight:600;color:#0f172a;background:#fff;cursor:pointer;">
              <option [value]="-1">Sin segundo horario</option>
              <option *ngFor="let h of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23]" [value]="h">
                {{ h < 12 ? h + ':00 AM' : h === 12 ? '12:00 PM' : (h - 12) + ':00 PM' }}
              </option>
            </select>
          </div>

          <!-- Horario terciario -->
          <div style="display:flex;align-items:center;gap:16px;padding-top:14px;border-top:1px solid #f1f5f9;">
            <div style="flex:1;">
              <div style="font-size:13px;font-weight:600;color:#0f172a;margin-bottom:2px;">Tercera ejecución (todas las fuentes, sin alertas)</div>
              <div style="font-size:11px;color:#94a3b8;">Corre todas las bolsas pero no envía alertas — útil para capturar vacantes nocturnas.</div>
            </div>
            <select [(ngModel)]="configForm.horaEjecucion3"
                    style="padding:7px 12px;border:1px solid #e2e8f0;border-radius:6px;font-size:14px;font-weight:600;color:#0f172a;background:#fff;cursor:pointer;">
              <option [value]="-1">Sin tercer horario</option>
              <option *ngFor="let h of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23]" [value]="h">
                {{ h < 12 ? h + ':00 AM' : h === 12 ? '12:00 PM' : (h - 12) + ':00 PM' }}
              </option>
            </select>
          </div>

        </div>
      </div>
      <button (click)="guardarConfig()" [disabled]="guardandoConfig"
              style="width:100%;padding:12px;background:#0ea5e9;color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:700;cursor:pointer;transition:background .15s;"
              [style.opacity]="guardandoConfig ? '0.7' : '1'"
              onmouseenter="this.style.background='#0284c7'"
              onmouseleave="this.style.background='#0ea5e9'">
        {{ guardandoConfig ? 'Guardando...' : 'Guardar Configuración' }}
      </button>

    </div>
  </div>
</section>

<!-- ── Tab: Historial ─────────────────────────────────────────────────────── -->
<section *ngIf="tabActiva === 'historial'" style="background:#f1f5f9;padding:28px 0 72px;">
  <div class="tg-container">

    <div style="margin-bottom:24px;display:flex;align-items:flex-start;justify-content:space-between;flex-wrap:wrap;gap:12px;">
      <div>
        <h2 style="font-size:17px;font-weight:700;color:#0f172a;margin:0 0 4px;">Historial de Ejecuciones</h2>
        <p style="font-size:13px;color:#64748b;margin:0;">Cada ejecución del scraper crea un registro. Puedes eliminar runs completos para revertir su importación.</p>
      </div>
      <div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;">
        <span *ngIf="mensajeEjecutar"
              style="font-size:13px;color:#15803d;background:#f0fdf4;border:1px solid #bbf7d0;border-radius:6px;padding:6px 12px;">
          ✓ {{mensajeEjecutar}}
        </span>
        <button (click)="cargarHistorial(); cargarStats()"
                [disabled]="cargandoHistorial"
                style="display:inline-flex;align-items:center;gap:6px;background:#fff;border:1px solid #cbd5e1;border-radius:6px;padding:6px 14px;font-size:13px;font-weight:600;color:#475569;cursor:pointer;"
                [style.opacity]="cargandoHistorial ? '0.6' : '1'">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
               stroke="currentColor" style="width:13px;height:13px;"
               [style.animation]="cargandoHistorial ? 'spin 1s linear infinite' : 'none'">
            <path stroke-linecap="round" stroke-linejoin="round"
                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/>
          </svg>
          {{ cargandoHistorial ? 'Actualizando...' : 'Actualizar' }}
        </button>
      </div>
    </div>

    <!-- Card en progreso -->
    <div *ngIf="scraperEnEjecucion"
         style="background:#fff;border:2px solid #0ea5e9;border-radius:14px;padding:20px 24px;margin-bottom:16px;">

      <!-- Título + fase + porcentaje -->
      <div style="display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:10px;margin-bottom:14px;">
        <div style="display:flex;align-items:center;gap:10px;">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
               stroke="#0ea5e9" style="width:18px;height:18px;flex-shrink:0;animation:spin 1s linear infinite;">
            <path stroke-linecap="round" stroke-linejoin="round"
                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/>
          </svg>
          <span style="font-size:14px;font-weight:700;color:#0f172a;">Scraping en curso</span>
          <span style="font-size:12px;color:#64748b;background:#f1f5f9;padding:2px 10px;border-radius:100px;">
            {{ progreso.fuente || 'Iniciando...' }}
          </span>
          <span *ngIf="progreso.iniciadoPor" style="font-size:11px;color:#64748b;">
            · por <strong>{{ progreso.iniciadoPor }}</strong>
            <ng-container *ngIf="progreso.iniciadoEn"> a las {{ progreso.iniciadoEn }}</ng-container>
          </span>
        </div>
        <span style="font-size:13px;font-weight:700;color:#0ea5e9;">{{ porcentaje }}%</span>
      </div>

      <!-- Barra de progreso -->
      <div style="background:#e2e8f0;border-radius:100px;height:8px;overflow:hidden;margin-bottom:16px;">
        <div [style.width]="porcentaje + '%'"
             style="height:100%;background:linear-gradient(90deg,#38bdf8,#0ea5e9);border-radius:100px;transition:width .4s ease;">
        </div>
      </div>

      <!-- Métricas por fuente -->
      <div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:12px;">
        <!-- OCC -->
        <ng-container *ngIf="configForm.occEnabled">
          <div [style.background]="progreso.occCount === 0 && progreso.fuente !== 'OCC' && progreso.fuente !== 'Iniciando...' ? '#fff7ed' : '#f0fdf4'"
               [style.border-color]="progreso.occCount === 0 && progreso.fuente !== 'OCC' && progreso.fuente !== 'Iniciando...' ? '#fed7aa' : '#bbf7d0'"
               style="border:1px solid;border-radius:8px;padding:8px 14px;min-width:90px;text-align:center;">
            <div style="font-size:10px;font-weight:700;color:#92400e;text-transform:uppercase;letter-spacing:.5px;margin-bottom:3px;">OCC</div>
            <div [style.color]="progreso.occCount === 0 && progreso.fuente !== 'OCC' && progreso.fuente !== 'Iniciando...' ? '#ea580c' : '#15803d'"
                 style="font-size:18px;font-weight:800;line-height:1;">
              {{ progreso.occCount }}
              <span *ngIf="progreso.occCount === 0 && progreso.fuente !== 'OCC' && progreso.fuente !== 'Iniciando...'" style="font-size:14px;">⚠</span>
            </div>
            <div *ngIf="progreso.occDup > 0 || (progreso.occCount > 0 && progreso.fuente !== 'OCC' && progreso.fuente !== 'Iniciando...')"
                 style="font-size:9px;color:#94a3b8;margin-top:2px;line-height:1.3;">
              <span style="color:#dc2626;">{{ progreso.occDup }}dup</span> / <span style="color:#16a34a;">{{ progreso.occCount - progreso.occDup }}✓</span>
            </div>
          </div>
          <div *ngIf="progreso.occError"
               style="display:flex;align-items:center;font-size:11px;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:6px 10px;max-width:260px;">
            <span style="white-space:pre-wrap;word-break:break-word;">{{ progreso.occError }}</span>
          </div>
        </ng-container>
        <!-- CT -->
        <ng-container *ngIf="configForm.ctEnabled">
          <div [style.background]="progreso.ctCount === 0 && progreso.fuente !== 'Computrabajo' && progreso.fuente !== 'OCC' && progreso.fuente !== 'Iniciando...' ? '#fff7ed' : '#fdf4ff'"
               [style.border-color]="progreso.ctCount === 0 && progreso.fuente !== 'Computrabajo' && progreso.fuente !== 'OCC' && progreso.fuente !== 'Iniciando...' ? '#fed7aa' : '#e9d5ff'"
               style="border:1px solid;border-radius:8px;padding:8px 14px;min-width:90px;text-align:center;">
            <div style="font-size:10px;font-weight:700;color:#7e22ce;text-transform:uppercase;letter-spacing:.5px;margin-bottom:3px;">Computrabajo</div>
            <div [style.color]="progreso.ctCount === 0 && progreso.fuente !== 'Computrabajo' && progreso.fuente !== 'OCC' && progreso.fuente !== 'Iniciando...' ? '#ea580c' : '#7c3aed'"
                 style="font-size:18px;font-weight:800;line-height:1;">
              {{ progreso.ctCount }}
              <span *ngIf="progreso.ctCount === 0 && progreso.fuente !== 'Computrabajo' && progreso.fuente !== 'OCC' && progreso.fuente !== 'Iniciando...'" style="font-size:14px;">⚠</span>
            </div>
            <div *ngIf="progreso.ctDup > 0 || (progreso.ctCount > 0 && progreso.fuente !== 'Computrabajo' && progreso.fuente !== 'OCC' && progreso.fuente !== 'Iniciando...')"
                 style="font-size:9px;color:#94a3b8;margin-top:2px;line-height:1.3;">
              <span style="color:#dc2626;">{{ progreso.ctDup }}dup</span> / <span style="color:#7c3aed;">{{ progreso.ctCount - progreso.ctDup }}✓</span>
            </div>
          </div>
          <div *ngIf="progreso.ctError"
               style="display:flex;align-items:center;font-size:11px;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:6px 10px;max-width:260px;">
            <span style="white-space:pre-wrap;word-break:break-word;">{{ progreso.ctError }}</span>
          </div>
        </ng-container>
        <!-- Hireline -->
        <ng-container *ngIf="configForm.hlEnabled">
          <div style="border:1px solid #bae6fd;border-radius:8px;padding:8px 14px;min-width:90px;text-align:center;background:#f0f9ff;">
            <div style="font-size:10px;font-weight:700;color:#0369a1;text-transform:uppercase;letter-spacing:.5px;margin-bottom:3px;">Hireline</div>
            <div style="font-size:18px;font-weight:800;line-height:1;color:#0284c7;">{{ progreso.hlCount }}</div>
            <div *ngIf="progreso.hlDup > 0 || (progreso.hlCount > 0 && progreso.fuente !== 'Hireline' && progreso.fuente !== 'OCC' && progreso.fuente !== 'Computrabajo' && progreso.fuente !== 'Iniciando...')"
                 style="font-size:9px;color:#94a3b8;margin-top:2px;line-height:1.3;">
              <span style="color:#dc2626;">{{ progreso.hlDup }}dup</span> / <span style="color:#0284c7;">{{ progreso.hlCount - progreso.hlDup }}✓</span>
            </div>
          </div>
          <div *ngIf="progreso.hlError"
               style="display:flex;align-items:center;font-size:11px;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:6px 10px;max-width:260px;">
            <span style="white-space:pre-wrap;word-break:break-word;">{{ progreso.hlError }}</span>
          </div>
        </ng-container>
        <!-- LinkedIn/Apify — una tarjeta por actor -->
        <ng-container *ngFor="let a of progreso.apifyActors">
          <div [style.border]="progreso.fuente.indexOf(a.label) !== -1 ? '2px solid #0e7490' : '1px solid #a5f3fc'"
               style="border-radius:8px;padding:8px 14px;min-width:90px;text-align:center;background:#ecfeff;">
            <div style="font-size:10px;font-weight:700;color:#0e7490;text-transform:uppercase;letter-spacing:.5px;margin-bottom:3px;">{{ a.label }}</div>
            <div style="font-size:18px;font-weight:800;line-height:1;color:#0891b2;">
              {{ a.saved > 0 ? a.saved : a.count }}
              <span *ngIf="progreso.fuente.indexOf(a.label) !== -1" style="font-size:11px;display:block;color:#0e7490;margin-top:2px;">ejecutando...</span>
              <span *ngIf="a.saved > 0 && a.count > a.saved" style="font-size:9px;display:block;color:#94a3b8;margin-top:1px;">{{ a.count }} obtenidas</span>
            </div>
            <div *ngIf="a.dup > 0" style="font-size:9px;color:#94a3b8;margin-top:2px;line-height:1.3;">
              <span style="color:#dc2626;">{{ a.dup }}dup</span> / <span style="color:#16a34a;">{{ a.count - a.dup }}✓</span>
            </div>
          </div>
          <div *ngIf="a.error"
               style="display:flex;align-items:center;font-size:11px;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:6px 10px;max-width:260px;">
            <span style="white-space:pre-wrap;word-break:break-word;">{{ a.label }}: {{ a.error }}</span>
          </div>
        </ng-container>
        <!-- Remotive -->
        <ng-container *ngIf="configForm.remotiveEnabled">
          <div [style.border]="progreso.fuente === 'Remotive' ? '2px solid #15803d' : '1px solid #bbf7d0'"
               style="border-radius:8px;padding:8px 14px;min-width:90px;text-align:center;background:#f0fdf4;">
            <div style="font-size:10px;font-weight:700;color:#15803d;text-transform:uppercase;letter-spacing:.5px;margin-bottom:3px;">Remotive</div>
            <div style="font-size:18px;font-weight:800;line-height:1;color:#16a34a;">{{ progreso.remotiveCount }}</div>
            <div *ngIf="progreso.remotiveDup > 0 || (progreso.remotiveCount > 0 && progreso.fuente !== 'Remotive' && progreso.fuente !== 'Iniciando...')"
                 style="font-size:9px;color:#94a3b8;margin-top:2px;line-height:1.3;">
              <span style="color:#dc2626;">{{ progreso.remotiveDup }}dup</span> / <span style="color:#16a34a;">{{ progreso.remotiveCount - progreso.remotiveDup }}✓</span>
            </div>
          </div>
          <div *ngIf="progreso.remotiveError"
               style="font-size:11px;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:6px 10px;max-width:200px;">
            {{ progreso.remotiveError }}
          </div>
        </ng-container>
        <!-- Himalayas -->
        <ng-container *ngIf="configForm.himalayanEnabled">
          <div [style.border]="progreso.fuente === 'Himalayas' ? '2px solid #15803d' : '1px solid #bbf7d0'"
               style="border-radius:8px;padding:8px 14px;min-width:90px;text-align:center;background:#f0fdf4;">
            <div style="font-size:10px;font-weight:700;color:#15803d;text-transform:uppercase;letter-spacing:.5px;margin-bottom:3px;">Himalayas</div>
            <div style="font-size:18px;font-weight:800;line-height:1;color:#16a34a;">{{ progreso.himalayanCount }}</div>
            <div *ngIf="progreso.himalayanDup > 0 || (progreso.himalayanCount > 0 && progreso.fuente !== 'Himalayas' && progreso.fuente !== 'Iniciando...')"
                 style="font-size:9px;color:#94a3b8;margin-top:2px;line-height:1.3;">
              <span style="color:#dc2626;">{{ progreso.himalayanDup }}dup</span> / <span style="color:#16a34a;">{{ progreso.himalayanCount - progreso.himalayanDup }}✓</span>
            </div>
          </div>
          <div *ngIf="progreso.himalayanError"
               style="font-size:11px;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:6px 10px;max-width:200px;">
            {{ progreso.himalayanError }}
          </div>
        </ng-container>
        <!-- Working Nomads -->
        <ng-container *ngIf="configForm.workingNomadsEnabled">
          <div [style.border]="progreso.fuente === 'WorkingNomads' ? '2px solid #15803d' : '1px solid #bbf7d0'"
               style="border-radius:8px;padding:8px 14px;min-width:90px;text-align:center;background:#f0fdf4;">
            <div style="font-size:10px;font-weight:700;color:#15803d;text-transform:uppercase;letter-spacing:.5px;margin-bottom:3px;">W.Nomads</div>
            <div style="font-size:18px;font-weight:800;line-height:1;color:#16a34a;">{{ progreso.workingNomadsCount }}</div>
            <div *ngIf="progreso.workingNomadsDup > 0 || (progreso.workingNomadsCount > 0 && progreso.fuente !== 'WorkingNomads' && progreso.fuente !== 'Iniciando...')"
                 style="font-size:9px;color:#94a3b8;margin-top:2px;line-height:1.3;">
              <span style="color:#dc2626;">{{ progreso.workingNomadsDup }}dup</span> / <span style="color:#16a34a;">{{ progreso.workingNomadsCount - progreso.workingNomadsDup }}✓</span>
            </div>
          </div>
          <div *ngIf="progreso.workingNomadsError"
               style="font-size:11px;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:6px 10px;max-width:200px;">
            {{ progreso.workingNomadsError }}
          </div>
        </ng-container>
        <!-- We Work Remotely -->
        <ng-container *ngIf="configForm.wwrEnabled">
          <div [style.border]="progreso.fuente === 'WeWorkRemotely' ? '2px solid #b45309' : '1px solid #fde68a'"
               style="border-radius:8px;padding:8px 14px;min-width:90px;text-align:center;background:#fffbeb;">
            <div style="font-size:10px;font-weight:700;color:#b45309;text-transform:uppercase;letter-spacing:.5px;margin-bottom:3px;">WWR</div>
            <div style="font-size:18px;font-weight:800;line-height:1;color:#d97706;">{{ progreso.wwrCount }}</div>
            <div *ngIf="progreso.wwrDup > 0 || (progreso.wwrCount > 0 && progreso.fuente !== 'WeWorkRemotely' && progreso.fuente !== 'Iniciando...')"
                 style="font-size:9px;color:#94a3b8;margin-top:2px;line-height:1.3;">
              <span style="color:#dc2626;">{{ progreso.wwrDup }}dup</span> / <span style="color:#d97706;">{{ progreso.wwrCount - progreso.wwrDup }}✓</span>
            </div>
          </div>
          <div *ngIf="progreso.wwrError"
               style="font-size:11px;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:6px 10px;max-width:200px;">
            {{ progreso.wwrError }}
          </div>
        </ng-container>
        <!-- Separador -->
        <div style="width:1px;background:#e2e8f0;margin:0 4px;"></div>
        <!-- Detalles -->
        <div style="border:1px solid #e2e8f0;border-radius:8px;padding:8px 14px;min-width:100px;text-align:center;background:#f8fafc;">
          <div style="font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.5px;margin-bottom:3px;">Detalles</div>
          <div style="font-size:13px;font-weight:700;line-height:1.4;">
            <span style="color:#15803d;">✓{{ progreso.detOk }}</span>
            <span style="color:#94a3b8;margin:0 4px;">/</span>
            <span [style.color]="progreso.detFail > 0 ? '#dc2626' : '#94a3b8'">✗{{ progreso.detFail }}</span>
          </div>
        </div>
        <!-- LLM -->
        <div style="border:1px solid #e2e8f0;border-radius:8px;padding:8px 14px;min-width:100px;text-align:center;background:#f8fafc;">
          <div style="font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.5px;margin-bottom:3px;">LLM/IA</div>
          <div style="font-size:13px;font-weight:700;line-height:1.4;">
            <span style="color:#15803d;">✓{{ progreso.llmOk }}</span>
            <span style="color:#94a3b8;margin:0 4px;">/</span>
            <span [style.color]="progreso.llmFail > 0 ? '#d97706' : '#94a3b8'">✗{{ progreso.llmFail }}</span>
          </div>
        </div>
      </div>

      <!-- Totales + nota duplicados -->
      <div style="display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:8px;">
        <span style="font-size:12px;color:#64748b;">
          Encontradas: <strong style="color:#0f172a;">{{ progreso.count }}</strong>
          &nbsp;·&nbsp;
          Nuevas: <strong style="color:#0f172a;">{{ progreso.count - progreso.dupRun - progreso.dupBD }}</strong>
          &nbsp;·&nbsp;
          Guardadas: <strong style="color:#16a34a;">{{ progreso.guardadas }}</strong>
          <span *ngIf="progreso.dupBD > 0 || progreso.dupRun > 0" style="color:#94a3b8;">
            &nbsp;({{ progreso.dupRun + progreso.dupBD }} dup)
          </span>
          <span *ngIf="progreso.errGuardado > 0" style="color:#dc2626;">
            &nbsp;· {{ progreso.errGuardado }} err
          </span>
        </span>
        <span style="font-size:11px;color:#94a3b8;">Actualizando cada 4 s…</span>
      </div>
    </div>

    <!-- Resumen de la última ejecución (visible tras completar) -->
    <div *ngIf="!scraperEnEjecucion && ultimoResumen"
         style="background:#f0fdf4;border:1px solid #86efac;border-radius:14px;padding:16px 20px;margin-bottom:16px;">
      <div style="font-size:13px;font-weight:700;color:#15803d;margin-bottom:12px;">✓ Última ejecución completada</div>
      <div style="display:flex;gap:8px;flex-wrap:wrap;">
        <!-- Por fuente -->
        <ng-container *ngIf="configForm.occEnabled">
          <div style="border:1px solid #bbf7d0;border-radius:8px;padding:6px 12px;background:#fff;text-align:center;min-width:75px;">
            <div style="font-size:9px;font-weight:700;color:#92400e;text-transform:uppercase;letter-spacing:.5px;margin-bottom:2px;">OCC</div>
            <div [style.color]="ultimoResumen.occCount === 0 ? '#ea580c' : '#15803d'"
                 style="font-size:17px;font-weight:800;line-height:1;">
              {{ ultimoResumen.occCount }}<span *ngIf="ultimoResumen.occCount === 0"> ⚠</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="configForm.ctEnabled">
          <div style="border:1px solid #bbf7d0;border-radius:8px;padding:6px 12px;background:#fff;text-align:center;min-width:75px;">
            <div style="font-size:9px;font-weight:700;color:#7e22ce;text-transform:uppercase;letter-spacing:.5px;margin-bottom:2px;">CT</div>
            <div [style.color]="ultimoResumen.ctCount === 0 ? '#ea580c' : '#7c3aed'"
                 style="font-size:17px;font-weight:800;line-height:1;">
              {{ ultimoResumen.ctCount }}<span *ngIf="ultimoResumen.ctCount === 0"> ⚠</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="configForm.hlEnabled">
          <div style="border:1px solid #bbf7d0;border-radius:8px;padding:6px 12px;background:#fff;text-align:center;min-width:75px;">
            <div style="font-size:9px;font-weight:700;color:#0369a1;text-transform:uppercase;letter-spacing:.5px;margin-bottom:2px;">Hireline</div>
            <div style="font-size:17px;font-weight:800;line-height:1;color:#0284c7;">{{ ultimoResumen.hlCount }}</div>
          </div>
        </ng-container>
        <div *ngFor="let a of ultimoResumen.apifyActors" style="border:1px solid #bbf7d0;border-radius:8px;padding:6px 12px;background:#fff;text-align:center;min-width:75px;">
          <div style="font-size:9px;font-weight:700;color:#0e7490;text-transform:uppercase;letter-spacing:.5px;margin-bottom:2px;">{{ a.label }}</div>
          <div style="font-size:17px;font-weight:800;line-height:1;color:#0891b2;">{{ a.saved || a.count }}</div>
          <div style="font-size:9px;color:#94a3b8;margin-top:2px;line-height:1.3;">
            <ng-container *ngIf="a.count > 0">
              <span style="color:#dc2626;">{{ a.dup }}dup</span> / <span style="color:#16a34a;">{{ a.count - a.dup }}✓</span>
              <span *ngIf="a.saved > 0 && a.count > a.saved" style="display:block;color:#94a3b8;">{{ a.count }} obtenidas</span>
            </ng-container>
          </div>
        </div>
        <ng-container *ngIf="configForm.remotiveEnabled">
          <div style="border:1px solid #bbf7d0;border-radius:8px;padding:6px 12px;background:#fff;text-align:center;min-width:75px;">
            <div style="font-size:9px;font-weight:700;color:#15803d;text-transform:uppercase;letter-spacing:.5px;margin-bottom:2px;">Remotive</div>
            <div style="font-size:17px;font-weight:800;line-height:1;color:#16a34a;">{{ ultimoResumen.remotiveCount }}</div>
          </div>
        </ng-container>
        <ng-container *ngIf="configForm.himalayanEnabled">
          <div style="border:1px solid #bbf7d0;border-radius:8px;padding:6px 12px;background:#fff;text-align:center;min-width:75px;">
            <div style="font-size:9px;font-weight:700;color:#15803d;text-transform:uppercase;letter-spacing:.5px;margin-bottom:2px;">Himalayas</div>
            <div style="font-size:17px;font-weight:800;line-height:1;color:#16a34a;">{{ ultimoResumen.himalayanCount }}</div>
          </div>
        </ng-container>
        <ng-container *ngIf="configForm.workingNomadsEnabled">
          <div style="border:1px solid #bbf7d0;border-radius:8px;padding:6px 12px;background:#fff;text-align:center;min-width:75px;">
            <div style="font-size:9px;font-weight:700;color:#15803d;text-transform:uppercase;letter-spacing:.5px;margin-bottom:2px;">W.Nomads</div>
            <div style="font-size:17px;font-weight:800;line-height:1;color:#16a34a;">{{ ultimoResumen.workingNomadsCount }}</div>
          </div>
        </ng-container>
        <ng-container *ngIf="configForm.wwrEnabled">
          <div style="border:1px solid #fde68a;border-radius:8px;padding:6px 12px;background:#fff;text-align:center;min-width:75px;">
            <div style="font-size:9px;font-weight:700;color:#b45309;text-transform:uppercase;letter-spacing:.5px;margin-bottom:2px;">WWR</div>
            <div style="font-size:17px;font-weight:800;line-height:1;color:#d97706;">{{ ultimoResumen.wwrCount }}</div>
          </div>
        </ng-container>
        <div style="width:1px;background:#bbf7d0;"></div>
        <div style="border:1px solid #bbf7d0;border-radius:8px;padding:6px 12px;background:#fff;min-width:120px;">
          <div style="font-size:9px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.5px;margin-bottom:4px;">Encontradas → Guardadas</div>
          <div style="font-size:13px;font-weight:700;color:#0f172a;">
            {{ ultimoResumen.count }} → <span style="color:#15803d;">{{ ultimoResumen.guardadas }}</span>
          </div>
          <div style="font-size:11px;color:#64748b;margin-top:2px;">
            {{ ultimoResumen.dupRun + ultimoResumen.dupBD }} duplicadas
          </div>
        </div>
        <div style="border:1px solid #bbf7d0;border-radius:8px;padding:6px 12px;background:#fff;min-width:110px;">
          <div style="font-size:9px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.5px;margin-bottom:4px;">Detalles / LLM</div>
          <div style="font-size:12px;font-weight:600;line-height:1.6;">
            <span style="color:#15803d;">✓{{ ultimoResumen.detOk }}</span>
            <span [style.color]="ultimoResumen.detFail > 0 ? '#dc2626' : '#94a3b8'"> ✗{{ ultimoResumen.detFail }}</span>
            <span style="color:#cbd5e1;margin:0 4px;">|</span>
            <span style="color:#15803d;">✓{{ ultimoResumen.llmOk }}</span>
            <span [style.color]="ultimoResumen.llmFail > 0 ? '#d97706' : '#94a3b8'"> ✗{{ ultimoResumen.llmFail }}</span>
          </div>
          <div *ngIf="ultimoResumen.errGuardado > 0" style="font-size:11px;color:#dc2626;margin-top:2px;">
            {{ ultimoResumen.errGuardado }} error(es) al guardar
          </div>
        </div>
      </div>
      <!-- Errores de fuentes que devolvieron 0 -->
      <div *ngIf="ultimoResumen.occError || ultimoResumen.ctError || ultimoResumen.hlError"
           style="margin-top:10px;padding:8px 12px;background:#fff7ed;border:1px solid #fed7aa;border-radius:6px;font-size:12px;color:#92400e;">
        <div *ngIf="ultimoResumen.occError" style="margin-bottom:2px;">
          <strong>OCC:</strong> {{ ultimoResumen.occError }}
        </div>
        <div *ngIf="ultimoResumen.ctError" style="margin-bottom:2px;">
          <strong>CT:</strong> {{ ultimoResumen.ctError }}
        </div>
        <div *ngIf="ultimoResumen.hlError">
          <strong>HL:</strong> {{ ultimoResumen.hlError }}
        </div>
      </div>
      <!-- Acciones sugeridas al admin para mejorar el scraper -->
      <div style="margin-top:10px;padding:10px 14px;background:#fefce8;border:1px solid #fde68a;border-radius:8px;font-size:12px;">
        <div style="font-weight:700;color:#92400e;margin-bottom:6px;">📋 Diagnóstico — ¿qué revisar?</div>
        <ul style="margin:0;padding-left:18px;font-size:11px;color:#78350f;line-height:1.8;">
          <li *ngIf="ultimoResumen.occError"><strong>OCC error:</strong> {{ ultimoResumen.occError }} — ¿proxy bloqueado? Ejecuta manualmente para reintentar.</li>
          <li *ngIf="ultimoResumen.ctError"><strong>CT error:</strong> {{ ultimoResumen.ctError }} — ¿proxy bloqueado? Ejecuta manualmente para reintentar.</li>
          <li *ngIf="ultimoResumen.hlError"><strong>HL error:</strong> {{ ultimoResumen.hlError }}</li>
          <li *ngIf="ultimoResumen.apifyError"><strong>LinkedIn error:</strong> {{ ultimoResumen.apifyError }}</li>
          <li *ngIf="(ultimoResumen.workingNomadsDup || 0) >= (ultimoResumen.workingNomadsCount || 1) && ultimoResumen.workingNomadsCount > 0">
            <strong>W.Nomads 100% dup</strong> — Abre los enlaces abajo para verificar si el fingerprint está fallando o no hay jobs nuevos.
          </li>
          <li *ngIf="(ultimoResumen.wwrDup || 0) >= (ultimoResumen.wwrCount || 1) && ultimoResumen.wwrCount > 0">
            <strong>WWR 100% dup</strong> — Abre los enlaces abajo para verificar si el fingerprint está fallando o no hay jobs nuevos.
          </li>
          <li *ngIf="(ultimoResumen.hlDup || 0) >= (ultimoResumen.hlCount || 0) * 0.8 && ultimoResumen.hlCount > 0">
            <strong>Hireline {{ ultimoResumen.hlDup }}/{{ ultimoResumen.hlCount }} dup</strong> — alta tasa de duplicados. Verifica URLs abajo.
          </li>
          <li *ngIf="ultimoResumen.llmFail > 0"><strong>LLM falló {{ ultimoResumen.llmFail }} veces</strong> — {{ ultimoResumen.llmError || 'revisa el token de IA en Admin > Config' }}</li>
          <li *ngIf="ultimoResumen.errGuardado > 0"><strong>{{ ultimoResumen.errGuardado }} errores al guardar</strong> — revisa logs del backend.</li>
          <li *ngIf="!ultimoResumen.occError && !ultimoResumen.ctError && !ultimoResumen.hlError && !ultimoResumen.apifyError && (ultimoResumen.workingNomadsDup || 0) < (ultimoResumen.workingNomadsCount || 1) && (ultimoResumen.wwrDup || 0) < (ultimoResumen.wwrCount || 1) && ultimoResumen.llmFail === 0 && ultimoResumen.errGuardado === 0">
            ✅ Sin incidencias detectadas. Todas las fuentes respondieron correctamente.
          </li>
        </ul>
      </div>

      <!-- Vacantes ya conocidas omitidas — con comparativa de URLs -->
      <div *ngIf="ultimoResumen.dupSampleUrls"
           style="margin-top:10px;padding:10px 14px;background:#f0f9ff;border:1px solid #bae6fd;border-radius:8px;font-size:12px;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
          <div>
            <span style="font-weight:700;color:#0369a1;">✓ Vacantes ya conocidas — omitidas sin procesar</span>
            <span style="font-size:10px;color:#64748b;display:block;margin-top:2px;">
              El sistema las reconoció y NO usó IA en ellas · muestra hasta 3 ejemplos por fuente
            </span>
          </div>
        </div>
        <div [innerHTML]="renderDupUrls(ultimoResumen.dupSampleUrls)"></div>
      </div>

      <!-- Advertencia si IA no procesó ninguna vacante -->
      <div *ngIf="ultimoResumen.llmOk === 0 && ultimoResumen.guardadas > 0"
           style="margin-top:10px;padding:10px 14px;background:#fef9c3;border:1px solid #fde047;border-radius:6px;font-size:12px;color:#713f12;">
        <strong>⚠ IA no procesó vacantes:</strong> Las {{ ultimoResumen.guardadas }} se guardaron sin enriquecimiento.
        <span *ngIf="ultimoResumen.llmError" style="display:block;margin-top:4px;color:#dc2626;font-family:monospace;font-size:11px;">
          Error: {{ ultimoResumen.llmError }}
        </span>
        Verifica el token en <a routerLink="/admin/config" style="color:#4f46e5;font-weight:600;">Admin → Configuración → DeepSeek</a>.
      </div>
    </div>

    <!-- Spinner cargando historial -->
    <div *ngIf="cargandoHistorial" style="text-align:center;padding:60px 0;color:#94a3b8;font-size:14px;">
      Cargando historial…
    </div>

    <!-- Empty state -->
    <div *ngIf="!cargandoHistorial && historial.length === 0"
         style="background:#fff;border:1px solid #e2e8f0;border-radius:14px;padding:60px;text-align:center;">
      <div style="font-size:2.5rem;margin-bottom:12px;">📋</div>
      <p style="color:#475569;font-size:15px;font-weight:600;margin:0 0 6px;">Sin ejecuciones registradas</p>
      <p style="color:#94a3b8;font-size:13px;margin:0;">Ejecuta el scraper para importar vacantes. Cada ejecución aparecerá aquí.</p>
    </div>

    <!-- Run cards -->
    <div *ngFor="let run of historial" style="margin-bottom:10px;">
      <div style="background:#fff;border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;transition:box-shadow .15s;"
           [style.border-color]="runExpandido === run.id ? '#0ea5e9' : '#e2e8f0'"
           onmouseenter="this.style.boxShadow='0 4px 12px rgba(0,0,0,.08)'"
           onmouseleave="this.style.boxShadow='none'">

        <!-- Run header row -->
        <div style="padding:16px 20px;display:flex;align-items:center;gap:16px;cursor:pointer;"
             (click)="toggleRun(run)">

          <!-- Icon -->
          <div style="flex-shrink:0;width:44px;height:44px;border-radius:10px;background:#eff6ff;display:flex;align-items:center;justify-content:center;font-size:18px;">
            🤖
          </div>

          <!-- Info -->
          <div style="flex:1;min-width:0;">
            <div style="display:flex;align-items:baseline;gap:8px;flex-wrap:wrap;margin-bottom:6px;">
              <span style="font-size:14px;font-weight:700;color:#0f172a;">
                {{ run.ejecutadoEn | appDate:'dd/MM/yyyy HH:mm:ss' }}
              </span>
              <span *ngIf="run.iniciadoPor" style="font-size:11px;color:#64748b;">
                por <strong style="color:#334155;">{{ run.iniciadoPor }}</strong>
              </span>
              <span *ngIf="run.duracionSegundos" style="font-size:11px;color:#64748b;background:#f1f5f9;padding:1px 7px;border-radius:100px;">
                ⏱ {{ formatDuracion(run.duracionSegundos) }}
              </span>
            </div>

            <!-- New format: metrics encoded in fuentes -->
            <div *ngIf="run.metricas as m" style="display:flex;flex-wrap:wrap;gap:6px;align-items:center;">
              <!-- Per-source counts -->
              <span [style.background]="m.occ === 0 ? '#fff7ed' : '#fef3c7'"
                    [style.color]="m.occ === 0 ? '#ea580c' : '#92400e'"
                    style="font-size:11px;font-weight:700;padding:2px 8px;border-radius:100px;border:1px solid currentColor;">
                OCC: {{ m.occ }}<ng-container *ngIf="m.occ > 0"> (<span style="color:#dc2626;">{{m.occDup}}dup</span> / {{m.occ - m.occDup}}✓)</ng-container><span *ngIf="m.occ === 0"> ⚠</span>
              </span>
              <span *ngIf="run.errores?.occ"
                    style="font-size:11px;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:6px;padding:2px 8px;max-width:300px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                    [title]="run.errores!.occ">
                ↳ {{ run.errores!.occ }}
              </span>
              <span [style.background]="m.ct === 0 ? '#fff7ed' : '#fdf4ff'"
                    [style.color]="m.ct === 0 ? '#ea580c' : '#7e22ce'"
                    style="font-size:11px;font-weight:700;padding:2px 8px;border-radius:100px;border:1px solid currentColor;">
                CT: {{ m.ct }}<ng-container *ngIf="m.ct > 0"> (<span style="color:#dc2626;">{{m.ctDup}}dup</span> / {{m.ct - m.ctDup}}✓)</ng-container><span *ngIf="m.ct === 0"> ⚠</span>
              </span>
              <span *ngIf="run.errores?.ct"
                    style="font-size:11px;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:6px;padding:2px 8px;max-width:300px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                    [title]="run.errores!.ct">
                ↳ {{ run.errores!.ct }}
              </span>
              <span style="font-size:11px;font-weight:700;padding:2px 8px;border-radius:100px;background:#e0f2fe;color:#0369a1;border:1px solid #0369a1;">
                HL: {{ m.hl }}<ng-container *ngIf="m.hl > 0"> (<span style="color:#dc2626;">{{m.hlDup}}dup</span> / {{m.hl - m.hlDup}}✓)</ng-container>
              </span>
              <span *ngIf="run.errores?.hl"
                    style="font-size:11px;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:6px;padding:2px 8px;max-width:300px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                    [title]="run.errores!.hl">
                ↳ {{ run.errores!.hl }}
              </span>
              <!-- LinkedIn/Apify — un badge y un error por actor, no agregado -->
              <ng-container *ngFor="let a of run.apifyActors">
                <span style="font-size:11px;font-weight:700;padding:2px 8px;border-radius:100px;background:#ecfeff;color:#0e7490;border:1px solid #0e7490;">
                  {{ a.label }}: {{ a.count }}<ng-container *ngIf="a.count > 0"> (<span style="color:#dc2626;">{{a.dup}}dup</span> / {{a.count - a.dup}}✓)</ng-container>
                </span>
                <span *ngIf="a.error"
                      style="font-size:11px;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:6px;padding:2px 8px;max-width:300px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                      [title]="a.error">
                  {{ a.label }} error: {{ a.error }}
                </span>
              </ng-container>
              <span *ngIf="m.remotive > 0" style="font-size:11px;font-weight:700;padding:2px 8px;border-radius:100px;background:#dcfce7;color:#15803d;border:1px solid #15803d;">
                Remotive: {{ m.remotive }} (<span style="color:#dc2626;">{{m.remotiveDup}}dup</span> / {{m.remotive - m.remotiveDup}}✓)
              </span>
              <span *ngIf="run.errores?.remotive"
                    style="font-size:11px;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:6px;padding:2px 8px;max-width:300px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                    [title]="run.errores!.remotive">
                ↳ {{ run.errores!.remotive }}
              </span>
              <span *ngIf="m.himalayan > 0" style="font-size:11px;font-weight:700;padding:2px 8px;border-radius:100px;background:#dcfce7;color:#15803d;border:1px solid #15803d;">
                Himalayas: {{ m.himalayan }} (<span style="color:#dc2626;">{{m.himalayanDup}}dup</span> / {{m.himalayan - m.himalayanDup}}✓)
              </span>
              <span *ngIf="run.errores?.himalayan"
                    style="font-size:11px;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:6px;padding:2px 8px;max-width:300px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                    [title]="run.errores!.himalayan">
                ↳ {{ run.errores!.himalayan }}
              </span>
              <span *ngIf="m.workingNomads > 0" style="font-size:11px;font-weight:700;padding:2px 8px;border-radius:100px;background:#dcfce7;color:#15803d;border:1px solid #15803d;">
                W.Nomads: {{ m.workingNomads }} (<span style="color:#dc2626;">{{m.workingNomadsDup}}dup</span> / {{m.workingNomads - m.workingNomadsDup}}✓)
              </span>
              <span *ngIf="run.errores?.workingNomads"
                    style="font-size:11px;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:6px;padding:2px 8px;max-width:300px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                    [title]="run.errores!.workingNomads">
                ↳ {{ run.errores!.workingNomads }}
              </span>
              <span *ngIf="m.wwr > 0" style="font-size:11px;font-weight:700;padding:2px 8px;border-radius:100px;background:#fef3c7;color:#b45309;border:1px solid #b45309;">
                WWR: {{ m.wwr }} (<span style="color:#dc2626;">{{m.wwrDup}}dup</span> / {{m.wwr - m.wwrDup}}✓)
              </span>
              <span *ngIf="run.errores?.wwr"
                    style="font-size:11px;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:6px;padding:2px 8px;max-width:300px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                    [title]="run.errores!.wwr">
                ↳ {{ run.errores!.wwr }}
              </span>
              <span style="font-size:11px;color:#94a3b8;">·</span>
              <!-- Detail + LLM stats -->
              <span style="font-size:11px;color:#64748b;">
                Detalles: <strong [style.color]="m.detFail > 0 ? '#dc2626' : '#15803d'">✓{{m.detOk}} ✗{{m.detFail}}</strong>
              </span>
              <span style="font-size:11px;color:#94a3b8;">·</span>
              <span style="font-size:11px;color:#64748b;">
                LLM: <strong [style.color]="m.llmFail > 0 ? '#d97706' : '#15803d'">✓{{m.llmOk}} ✗{{m.llmFail}}</strong>
              </span>
              <span *ngIf="m.llmOk === 0 && run.totalVacantes > 0"
                    style="font-size:11px;font-weight:700;padding:2px 8px;border-radius:100px;background:#fef9c3;color:#92400e;border:1px solid #fde047;">
                ⚠ Sin IA
              </span>
              <span *ngIf="m.dup > 0" style="font-size:11px;color:#94a3b8;">· {{m.dup}} dup</span>
              <span style="font-size:11px;color:#94a3b8;">·</span>
              <span style="font-size:12px;color:#64748b;">
                <strong style="color:#0f172a;">{{ run.totalVacantes }}</strong> guardadas
              </span>
            </div>

            <!-- Old format: just source badges -->
            <div *ngIf="!run.metricas" style="display:flex;flex-wrap:wrap;gap:6px;align-items:center;">
              <span style="font-size:12px;color:#64748b;">
                <strong style="color:#0f172a;">{{ run.totalVacantes }}</strong> vacante(s) importadas
              </span>
              <span style="font-size:11px;color:#94a3b8;">·</span>
              <span *ngFor="let fuente of run.fuentes.split(',')"
                    style="font-size:10px;font-weight:700;padding:2px 7px;border-radius:100px;background:#f1f5f9;color:#334155;">
                {{ fuente.trim() }}
              </span>
            </div>
          </div>

          <!-- Expand toggle -->
          <span style="font-size:12px;color:#0ea5e9;font-weight:600;flex-shrink:0;margin-right:8px;">
            {{ runExpandido === run.id ? '▲ Cerrar' : '▼ Ver vacantes' }}
          </span>

          <!-- Delete button -->
          <button (click)="$event.stopPropagation(); eliminarRun(run)" [disabled]="eliminandoRun === run.id"
                  style="flex-shrink:0;display:inline-flex;align-items:center;gap:6px;padding:7px 14px;border:1px solid #fecaca;background:#fff5f5;color:#dc2626;border-radius:8px;font-size:12px;font-weight:600;cursor:pointer;transition:all .15s;"
                  onmouseenter="this.style.background='#fee2e2'"
                  onmouseleave="this.style.background='#fff5f5'"
                  [style.opacity]="eliminandoRun === run.id ? '0.6' : '1'">
            <span *ngIf="eliminandoRun === run.id">Eliminando…</span>
            <span *ngIf="eliminandoRun !== run.id">🗑 Eliminar</span>
          </button>
        </div>

        <!-- Vacantes expandidas -->
        <div *ngIf="runExpandido === run.id"
             style="border-top:1px solid #f1f5f9;background:#fafafa;max-height:520px;overflow-y:auto;">

          <!-- Loading -->
          <div *ngIf="cargandoVacantes === run.id"
               style="text-align:center;padding:32px;font-size:13px;color:#94a3b8;">
            Cargando vacantes…
          </div>

          <!-- Source filter -->
          <div *ngIf="cargandoVacantes !== run.id && vacantesPorRun[run.id]"
               style="display:flex;align-items:center;gap:6px;flex-wrap:wrap;padding:10px 16px;border-bottom:1px solid #e2e8f0;background:#f8fafc;">
            <span style="font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.5px;margin-right:4px;">Fuente:</span>
            <button *ngFor="let f of [['ALL','Todas'],['OCC','OCC'],['COMPUTRABAJO','CT'],['HIRELINE','Hireline'],['APIFY_LINKEDIN','LinkedIn'],['REMOTIVE','Remotive'],['HIMALAYAS','Himalayas'],['WORKING_NOMADS','W.Nomads'],['WWR','WWR']]"
                    (click)="filtroFuenteRun = f[0]; $event.stopPropagation()"
                    [style.background]="filtroFuenteRun === f[0] ? '#0ea5e9' : '#fff'"
                    [style.color]="filtroFuenteRun === f[0] ? '#fff' : '#475569'"
                    [style.border-color]="filtroFuenteRun === f[0] ? '#0ea5e9' : '#cbd5e1'"
                    style="font-size:11px;font-weight:600;padding:3px 10px;border:1px solid;border-radius:100px;cursor:pointer;transition:all .15s;">
              {{ f[1] }}
            </button>
            <span style="margin-left:auto;font-size:11px;color:#94a3b8;">
              {{ vacantesDeRun(run.id).length }} / {{ vacantesPorRun[run.id].length }}
            </span>
          </div>

          <!-- Table header -->
          <div *ngIf="cargandoVacantes !== run.id && vacantesPorRun[run.id]"
               style="display:grid;grid-template-columns:1fr 140px 90px 90px 90px;gap:8px;padding:10px 16px;border-bottom:1px solid #e2e8f0;background:#f1f5f9;">
            <span style="font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.5px;">Vacante</span>
            <span style="font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.5px;">Empresa scraped</span>
            <span style="font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.5px;">Fuente</span>
            <span style="font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.5px;">Links</span>
            <span style="font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.5px;">Acciones</span>
          </div>

          <!-- Vacante rows -->
          <div *ngFor="let v of vacantesDeRun(run.id); let odd = odd"
               style="display:grid;grid-template-columns:1fr 140px 90px 90px 90px;gap:8px;padding:9px 16px;align-items:start;border-bottom:1px solid #f1f5f9;"
               [style.background]="v.activa === false ? '#fef2f2' : (odd ? '#f8fafc' : '#fff')"
               [style.opacity]="v.activa === false ? '0.65' : '1'">

            <!-- Título -->
            <div style="min-width:0;">
              <div style="font-size:13px;font-weight:600;color:#0f172a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                   [title]="v.nombre">
                {{ v.nombre }}
              </div>
              <div *ngIf="v.direccion" style="font-size:11px;color:#94a3b8;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                {{ v.direccion }}
              </div>
              <div *ngIf="v.detailError"
                   style="margin-top:3px;font-size:11px;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:4px;padding:2px 6px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                   [title]="v.detailError">
                ⚠ {{ v.detailError }}
              </div>
            </div>

            <!-- Empresa scraped -->
            <div style="font-size:12px;color:#475569;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                 [title]="v.scrapeCompany">
              {{ v.scrapeCompany || '—' }}
            </div>

            <!-- Fuente badge -->
            <div>
              <span style="font-size:10px;font-weight:700;padding:2px 8px;border-radius:100px;"
                    [ngStyle]="{'background': v.scrapeFuente==='OCC' ? '#fef3c7' : v.scrapeFuente==='COMPUTRABAJO' ? '#fce7f3' : v.scrapeFuente==='APIFY_LINKEDIN' ? '#ecfeff' : '#e0f2fe',
                                'color':      v.scrapeFuente==='OCC' ? '#92400e' : v.scrapeFuente==='COMPUTRABAJO' ? '#9d174d' : v.scrapeFuente==='APIFY_LINKEDIN' ? '#0e7490' : '#0369a1'}">
                {{ v.scrapeFuente === 'APIFY_LINKEDIN' ? 'LinkedIn' : v.scrapeFuente }}
              </span>
            </div>

            <!-- Links -->
            <div style="display:flex;gap:6px;flex-wrap:wrap;">
              <a [routerLink]="['/vacantes/detalles', v.urlVacante]" target="_blank"
                 style="font-size:11px;color:#0ea5e9;text-decoration:none;padding:3px 8px;border:1px solid #bae6fd;border-radius:5px;background:#f0f9ff;white-space:nowrap;">
                Ver en TG
              </a>
              <a *ngIf="v.scrapeUrlOriginal" [href]="v.scrapeUrlOriginal" target="_blank"
                 style="font-size:11px;color:#64748b;text-decoration:none;padding:3px 8px;border:1px solid #e2e8f0;border-radius:5px;background:#f8fafc;white-space:nowrap;">
                Original ↗
              </a>
            </div>

            <!-- Acciones -->
            <div>
              <span *ngIf="v.activa === false"
                    style="font-size:10px;font-weight:700;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:100px;padding:2px 8px;">
                Eliminada
              </span>
              <button *ngIf="v.activa !== false"
                      (click)="rechazarVacanteIndividual(run.id, v.id)"
                      [disabled]="rechazandoVacante.has(v.id)"
                      style="display:inline-flex;align-items:center;gap:4px;font-size:11px;color:#dc2626;background:#fff5f5;border:1px solid #fecaca;border-radius:6px;padding:4px 8px;cursor:pointer;transition:background .15s;"
                      onmouseenter="this.style.background='#fee2e2'"
                      onmouseleave="this.style.background='#fff5f5'"
                      [style.opacity]="rechazandoVacante.has(v.id) ? '0.6' : '1'">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style="width:11px;height:11px;">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"/>
                </svg>
                {{ rechazandoVacante.has(v.id) ? '...' : 'Eliminar' }}
              </button>
            </div>

          </div>

          <!-- Empty -->
          <div *ngIf="cargandoVacantes !== run.id && vacantesDeRun(run.id)?.length === 0"
               style="text-align:center;padding:32px;font-size:13px;color:#94a3b8;">
            <ng-container *ngIf="filtroFuenteRun === 'ALL'">Sin vacantes registradas para este run.</ng-container>
            <ng-container *ngIf="filtroFuenteRun !== 'ALL'">Sin vacantes de {{ fuenteLabel(filtroFuenteRun) }} en este run.</ng-container>
          </div>

          <!-- Descartadas no TI: trazabilidad disponible a partir de esta versión -->
          <div *ngIf="cargandoVacantes !== run.id && resultadosPorRun[run.id]"
               style="border-top:3px solid #fed7aa;background:#fff7ed;">
            <div style="padding:11px 16px;display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid #fed7aa;">
              <strong style="font-size:13px;color:#9a3412;">Descartadas por no ser TI</strong>
              <span style="font-size:12px;font-weight:700;color:#9a3412;">{{ noTiDeRun(run.id).length }}</span>
            </div>
            <div *ngFor="let item of noTiDeRun(run.id); let odd = odd"
                 style="display:grid;grid-template-columns:1fr 150px 100px 2fr 80px;gap:10px;padding:10px 16px;border-bottom:1px solid #ffedd5;align-items:start;"
                 [style.background]="odd ? '#fffaf5' : '#fff'">
              <div>
                <div style="font-size:12px;font-weight:700;color:#431407;">{{ item.titulo }}</div>
                <div style="font-size:11px;color:#9a3412;">{{ item.empresa || 'Empresa no informada' }}</div>
              </div>
              <span style="font-size:11px;color:#7c2d12;">{{ item.fuente === 'APIFY_LINKEDIN' ? 'LinkedIn' : item.fuente }}</span>
              <span style="font-size:10px;font-weight:700;color:#9a3412;background:#ffedd5;border-radius:100px;padding:3px 7px;text-align:center;">NO TI</span>
              <div style="font-size:11px;color:#7c2d12;line-height:1.4;">{{ item.motivo || 'La IA la clasificó como no TI.' }}</div>
              <a *ngIf="item.urlOriginal" [href]="item.urlOriginal" target="_blank"
                 style="font-size:11px;color:#c2410c;text-decoration:none;">Original ↗</a>
            </div>
            <div *ngIf="noTiDeRun(run.id).length === 0" style="padding:14px 16px;font-size:12px;color:#9a3412;">
              {{ resultadosPorRun[run.id].length === 0 ? 'Esta corrida es anterior al despliegue de trazabilidad detallada.' : 'No hubo descartadas no TI con este filtro.' }}
            </div>
            <div *ngIf="fallosDeRun(run.id).length > 0" style="padding:9px 16px;background:#fef2f2;color:#991b1b;font-size:11px;border-top:1px solid #fecaca;">
              Además hubo {{ fallosDeRun(run.id).length }} candidatas con fallo de IA o de guardado; ya no se contabilizan incorrectamente como no TI.
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>

  <!-- Modal de Confirmación del Scraper -->
  <div *ngIf="mostrarConfirmacionScraper" (click)="cerrarConfirmacion()"
       style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.6);z-index:9999;display:flex;align-items:center;justify-content:center;">
    <div (click)="$event.stopPropagation()"
         style="background:#fff;border-radius:12px;padding:28px;max-width:520px;width:90%;max-height:85vh;overflow-y:auto;box-shadow:0 20px 60px rgba(0,0,0,0.3);">
      <h3 style="margin:0 0 16px;font-size:16px;color:#0f172a;">⚙️ Configuración del Scraper</h3>
      <div [style.background]="iaSet ? '#ecfdf5' : '#fef3c7'" style="padding:10px 14px;border-radius:8px;margin-bottom:12px;font-size:13px;">
        <strong [style.color]="iaSet ? '#059669' : '#d97706'">{{ iaSet ? '✅ IA Configurada (DeepSeek)' : '⚠ IA No Configurada' }}</strong>
        <span style="color:#059669;display:block;margin-top:2px;" *ngIf="iaSet">Modelo: {{ configForm.iaModelo }} — se enriquecerán descripciones y datos.</span>
        <span style="color:#92400e;display:block;margin-top:2px;" *ngIf="!iaSet">Configura el token en <a (click)="cerrarConfirmacion()" routerLink="/admin/config" style="color:#4f46e5;text-decoration:underline;">Admin → Configuración → DeepSeek</a></span>
      </div>
      <div style="font-size:13px;color:#334155;margin-bottom:8px;"><strong>Fuentes activas:</strong></div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:5px;font-size:12px;margin-bottom:14px;">
        <span [style.opacity]="configForm.occEnabled ? '1' : '0.4'">📰 OCC {{ configForm.occEnabled ? '✅' : '⛔' }}</span>
        <span [style.opacity]="configForm.ctEnabled ? '1' : '0.4'">💼 CT {{ configForm.ctEnabled ? '✅' : '⛔' }}</span>
        <span [style.opacity]="configForm.hlEnabled ? '1' : '0.4'">🎯 Hireline {{ configForm.hlEnabled ? '✅' : '⛔' }}</span>
        <span [style.opacity]="apifyActorsActivos() > 0 ? '1' : '0.4'">🔗 LinkedIn {{ apifyActorsActivos() > 0 ? '✅' : '⛔' }} ({{ apifyActorsActivos() }})</span>
        <span [style.opacity]="configForm.remotiveEnabled ? '1' : '0.4'">🌍 Remotive {{ configForm.remotiveEnabled ? '✅' : '⛔' }}</span>
        <span [style.opacity]="configForm.himalayanEnabled ? '1' : '0.4'">🏔 Himalayas {{ configForm.himalayanEnabled ? '✅' : '⛔' }}</span>
        <span [style.opacity]="configForm.workingNomadsEnabled ? '1' : '0.4'">🧳 W.Nomads {{ configForm.workingNomadsEnabled ? '✅' : '⛔' }}</span>
        <span [style.opacity]="configForm.wwrEnabled ? '1' : '0.4'">🏠 WWR {{ configForm.wwrEnabled ? '✅' : '⛔' }}</span>
      </div>
      <div style="display:flex;gap:10px;justify-content:flex-end;">
        <button (click)="cerrarConfirmacion()" style="background:#e2e8f0;color:#475569;border:none;border-radius:6px;padding:8px 18px;font-size:13px;font-weight:600;cursor:pointer;">Cancelar</button>
        <button (click)="confirmarEjecutar()" [style.background]="iaSet ? '#0ea5e9' : '#f59e0b'" style="color:#fff;border:none;border-radius:6px;padding:8px 18px;font-size:13px;font-weight:600;cursor:pointer;">{{ iaSet ? '▶ Ejecutar Scraper' : '⚠ Ejecutar sin IA' }}</button>
      </div>
    </div>
  </div>

  <!-- Modal: vacantes huerfanas detectadas -->
  <div *ngIf="mostrarConfirmacionOrphans" style="position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:1000;display:flex;align-items:center;justify-content:center;">
    <div style="background:#fff;border-radius:12px;padding:28px 32px;max-width:420px;width:90%;box-shadow:0 20px 60px rgba(0,0,0,.3);">
      <div style="font-size:24px;text-align:center;margin-bottom:12px;">⚠️</div>
      <h3 style="color:#0f172a;font-size:16px;font-weight:700;margin:0 0 10px;text-align:center;">Registros huérfanos detectados</h3>
      <p style="color:#475569;font-size:14px;margin:0 0 20px;text-align:center;">
        Encontré <strong style="color:#dc2626;">{{ orphanCount }} vacante{{ orphanCount !== 1 ? 's' : '' }}</strong>
        en MongoDB sin detalles en MySQL.<br>¿Deseas eliminarlas antes de ejecutar el scraper?
      </p>
      <div style="display:flex;gap:10px;justify-content:center;">
        <button (click)="omitirOrphansYEjecutar()" style="background:#e2e8f0;color:#475569;border:none;border-radius:6px;padding:8px 18px;font-size:13px;font-weight:600;cursor:pointer;">No, continuar</button>
        <button (click)="limpiarOrphansYEjecutar()" style="background:#dc2626;color:#fff;border:none;border-radius:6px;padding:8px 18px;font-size:13px;font-weight:600;cursor:pointer;">Si, eliminar y ejecutar</button>
      </div>
    </div>
  </div>

</section>

<style>
  @keyframes spin { to { transform: rotate(360deg); } }
</style>
